<template>
  <gv-modal
    data-theme="mobile"
    :modal="modal"
    size="custom"
    :custom-size-class="tw`w-[calc(100vw-2rem)] xs:w-[480px] h-[448px]`"
    layout="flex-col"
    :close-on-click-outside="false"
    :border-radius="tw`rounded-2xl`"
  >
    <template #header>
      <div class="flex items-center pl-2 pt-2">
        <div class="flex size-10 items-center justify-center">
          <gv-button variant="text" scheme="custom" size="custom" type="button" @click.stop="modal.setClosed">
            <gv-icon name="close" aria-label="Close" size="sm" class="fill-grey-300" />
          </gv-button>
        </div>
      </div>
    </template>
    <suspense>
      <mep-warning-levels-carousel card-variant="modal" />
      <template #fallback>
        <div class="flex grow items-center justify-center self-stretch">
          <ui-spinner size="sm" tabindex="0" aria-label="Loading" />
        </div>
      </template>
    </suspense>
  </gv-modal>
</template>

<script lang="ts" setup>
import { inject } from 'vue';
import * as Symbols from '@/common/constants/symbols';
import { tw } from '@/common';

const { modal } = {
  modal: inject(Symbols.MyEmergencyPlanWarningLevelsModal)!,
};
</script>
